import { i18n } from "@dehub/theme";

import mnCommon from "./locales/mn/common.json";
import enCommon from "./locales/en/common.json";
import koCommon from "./locales/ko/common.json";
import zhCommon from "./locales/zh/common.json";

import mnErrors from "./locales/mn/errors.json";
import enErrors from "./locales/en/errors.json";
import koErrors from "./locales/ko/errors.json";
import zhErrors from "./locales/zh/errors.json";

import mnLayout from "./locales/mn/layout.json";
import enLayout from "./locales/en/layout.json";
import koLayout from "./locales/ko/layout.json";
import zhLayout from "./locales/zh/layout.json";

import mnDashboard from "./locales/mn/dashboard.json";
import enDashboard from "./locales/en/dashboard.json";
import koDashboard from "./locales/ko/dashboard.json";
import zhDashboard from "./locales/zh/dashboard.json";

import mnInvoice from "./locales/mn/invoice.json";
import enInvoice from "./locales/en/invoice.json";
import koInvoice from "./locales/ko/invoice.json";
import zhInvoice from "./locales/zh/invoice.json";

import mnReturns from "./locales/mn/returns.json";
import enReturns from "./locales/en/returns.json";
import koReturns from "./locales/ko/returns.json";
import zhReturns from "./locales/zh/returns.json";

import mnReconciliation from "./locales/mn/reconciliation.json";
import enReconciliation from "./locales/en/reconciliation.json";
import koReconciliation from "./locales/ko/reconciliation.json";
import zhReconciliation from "./locales/zh/reconciliation.json";

import mnSettlement from "./locales/mn/settlement.json";
import enSettlement from "./locales/en/settlement.json";
import koSettlement from "./locales/ko/settlement.json";
import zhSettlement from "./locales/zh/settlement.json";

import mnSettings from "./locales/mn/settings.json";
import enSettings from "./locales/en/settings.json";
import koSettings from "./locales/ko/settings.json";
import zhSettings from "./locales/zh/settings.json";

import mnBilling from "./locales/mn/billing.json";
import enBilling from "./locales/en/billing.json";
import koBilling from "./locales/ko/billing.json";
import zhBilling from "./locales/zh/billing.json";

i18n.addResourceBundle("mn", "common", mnCommon, true, true);
i18n.addResourceBundle("en", "common", enCommon, true, true);
i18n.addResourceBundle("ko", "common", koCommon, true, true);
i18n.addResourceBundle("zh", "common", zhCommon, true, true);

i18n.addResourceBundle("mn", "errors", mnErrors, true, true);
i18n.addResourceBundle("en", "errors", enErrors, true, true);
i18n.addResourceBundle("ko", "errors", koErrors, true, true);
i18n.addResourceBundle("zh", "errors", zhErrors, true, true);

i18n.addResourceBundle("mn", "layout", mnLayout, true, true);
i18n.addResourceBundle("en", "layout", enLayout, true, true);
i18n.addResourceBundle("ko", "layout", koLayout, true, true);
i18n.addResourceBundle("zh", "layout", zhLayout, true, true);

i18n.addResourceBundle("mn", "dashboard", mnDashboard, true, true);
i18n.addResourceBundle("en", "dashboard", enDashboard, true, true);
i18n.addResourceBundle("ko", "dashboard", koDashboard, true, true);
i18n.addResourceBundle("zh", "dashboard", zhDashboard, true, true);

i18n.addResourceBundle("mn", "invoice", mnInvoice, true, true);
i18n.addResourceBundle("en", "invoice", enInvoice, true, true);
i18n.addResourceBundle("ko", "invoice", koInvoice, true, true);
i18n.addResourceBundle("zh", "invoice", zhInvoice, true, true);

i18n.addResourceBundle("mn", "returns", mnReturns, true, true);
i18n.addResourceBundle("en", "returns", enReturns, true, true);
i18n.addResourceBundle("ko", "returns", koReturns, true, true);
i18n.addResourceBundle("zh", "returns", zhReturns, true, true);

i18n.addResourceBundle("mn", "reconciliation", mnReconciliation, true, true);
i18n.addResourceBundle("en", "reconciliation", enReconciliation, true, true);
i18n.addResourceBundle("ko", "reconciliation", koReconciliation, true, true);
i18n.addResourceBundle("zh", "reconciliation", zhReconciliation, true, true);

i18n.addResourceBundle("mn", "settlement", mnSettlement, true, true);
i18n.addResourceBundle("en", "settlement", enSettlement, true, true);
i18n.addResourceBundle("ko", "settlement", koSettlement, true, true);
i18n.addResourceBundle("zh", "settlement", zhSettlement, true, true);

i18n.addResourceBundle("mn", "settings", mnSettings, true, true);
i18n.addResourceBundle("en", "settings", enSettings, true, true);
i18n.addResourceBundle("ko", "settings", koSettings, true, true);
i18n.addResourceBundle("zh", "settings", zhSettings, true, true);

i18n.addResourceBundle("mn", "billing", mnBilling, true, true);
i18n.addResourceBundle("en", "billing", enBilling, true, true);
i18n.addResourceBundle("ko", "billing", koBilling, true, true);
i18n.addResourceBundle("zh", "billing", zhBilling, true, true);

const APP_NAMESPACES = [
  "common", "layout", "dashboard", "invoice",
  "returns", "reconciliation", "settlement", "settings", "billing", "errors",
];
i18n.options.ns = Array.from(new Set([...(i18n.options.ns as string[] || []), ...APP_NAMESPACES]));
i18n.loadNamespaces(APP_NAMESPACES);
